export const MPP_PAGE_VIEWED = 'mpp.page.viewed';
export const SPP_PAGE_VIEWED = 'spp.page.viewed';
export const PRODUCT_FULL_LOADED = 'product.full.loaded';
export const SPP_POWER_REVIEWS_INIT = 'spp.powerReviews.init';
export const READ_REVIEWS_LINK_CLICKED = 'read.reviews.link.clicked';
export const WRITE_REVIEWS_LINK_CLICKED = 'write.reviews.link.clicked';
export const MPP_FILTERED = 'mpp.filtered';
export const GRID_SORTED = 'grid.sorted';
export const GRID_FILTERED = 'grid.filtered';
export const PRODUCT_LOADED = 'product.loaded';
export const PRODUCT_VIEWED = 'product.viewed';
export const PRODUCT_CLICKED = 'product.clicked';
export const PRODUCTS_FILTERED_AND_SORTED = 'product.filteredAndSorted';
export const SPP_PAGE_LOADED = 'spp.page.loaded';
export const SPP_SELECTION = 'spp.shade.size.selected';
export const PRODUCT_SHADE_SIZE_SELECTED = 'product.shadeSizeSelected';
export const QUICK_VIEW_TRIGGERED = 'quick.view.triggered';
export const SKU_ENGRAVING_TRIGGERED = 'sku.engraving.triggered';
export const PRODUCT_SHADE_SELECTED = 'product.shadeSelected';
export const ADD_SKU_TO_COLLECTION_TRIGGERED = 'sku.addToCollection';
export const PRODUCT_INFO_POPUP_CTA_CLICKED = 'product.infoPopupCtaClicked';

enum FILTER_METHODS {
    filter = 'filter',
    sort = 'sort'
}

export interface IAppliedFilter {
    category: string;
    option: string;
}

export interface IMPPPageViewedEvent {
    skuIds: string[];
}
interface IProductFullLoaded {
    productId: string;
    skuId: string;
}

export interface IMppFiltered {
    method: FILTER_METHODS;
}
export interface IGridFitlered {
    appliedFilters: IAppliedFilter[];
}

export interface IGridSorted {
    appliedSort: string;
}

export interface IProductInfoPopupPayload {
    dataField: string;
    level?: string;
    header?: string;
}

export interface ISkuEngravingEvent {
    skuId: string;
    skuBaseId?: number;
    size: string;
    price: string;
    name: string;
}
export type ServiceProdcatEvents = {
    [MPP_PAGE_VIEWED]: IMPPPageViewedEvent;
    [SPP_PAGE_VIEWED]: string;
    [PRODUCT_FULL_LOADED]: IProductFullLoaded;
    [SPP_POWER_REVIEWS_INIT]: string;
    [READ_REVIEWS_LINK_CLICKED]: { productId: string; displayName: string };
    [WRITE_REVIEWS_LINK_CLICKED]: { productId: string; displayName: string };
    [MPP_FILTERED]: IMppFiltered;
    [GRID_SORTED]: IGridSorted;
    [GRID_FILTERED]: IGridFitlered;
    [PRODUCT_LOADED]: string[];
    [PRODUCT_VIEWED]: { skuId: string };
    [PRODUCT_CLICKED]: { skuId: string; positionIndex: number };
    [PRODUCTS_FILTERED_AND_SORTED]: {};
    [SPP_PAGE_LOADED]: {};
    [SPP_SELECTION]: {};
    [PRODUCT_SHADE_SIZE_SELECTED]: {};
    [QUICK_VIEW_TRIGGERED]: { skuId: string; positionIndex: number };
    [SKU_ENGRAVING_TRIGGERED]: ISkuEngravingEvent;
    [PRODUCT_SHADE_SELECTED]: { skuId: string };
    [ADD_SKU_TO_COLLECTION_TRIGGERED]: { skuId: string; quantity?: number };
    [PRODUCT_INFO_POPUP_CTA_CLICKED]: IProductInfoPopupPayload;
};
